import { render } from "./ResultCardModal.vue?vue&type=template&id=46080039&ts=true"
import script from "./ResultCardModal.vue?vue&type=script&lang=ts"
export * from "./ResultCardModal.vue?vue&type=script&lang=ts"

import "./ResultCardModal.vue?vue&type=style&index=0&id=46080039&lang=scss"

import exportComponent from "/builds/atx/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__